import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { IConnectionTypeEmailIntegration } from 'app/environment/typings/IConnectionTypeEmailIntegration';




@Injectable()
export class IntegrationService {

    private api_testEmail = 'api/integration/testEmail';
    private api_getEmailConnectionTypes = 'api/integration/emailintegration/connectiontypes';

    constructor(private _authHttp: RestApi) { }

    testEmail(params: any) {
        return this._authHttp.post(this.api_testEmail, params);
    }

    getEmailConnectionTypes(): Promise<Array<IConnectionTypeEmailIntegration>> {
        return this._authHttp.get(this.api_getEmailConnectionTypes).toPromise();
    }

}
